module.exports = __webpack_public_path__ + "img/17a003-08.1aab1284.jpg";